import script from "./MenuButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuButton.vue?vue&type=script&setup=true&lang=js"

import "./MenuButton.vue?vue&type=style&index=0&id=d517bbb8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d517bbb8"]])

export default __exports__